import { useContext, useEffect } from "react";
import TitleContext from "../context/TitleContext";
import ViewProfileComponent from "../components/auth/profile/ViewProfile";

const MyProfilePage = () => {
  const { setTitle } = useContext(TitleContext);

  useEffect(() => {
    setTitle("My Profile");
  }, [setTitle]);
  return (
    <>
      <ViewProfileComponent />
    </>
  );
};
export default MyProfilePage;
